import { createTheme } from "@mui/material/styles";
import { lightColors, darkColors } from "./tokens/colors";
import { typography, breakpoints, zIndices, radii, shadows } from "./tokens";

/**
 * Create MUI theme based on mode (light/dark).
 * Colour values are DERIVED exclusively from tokens/colors.js
 * (lightColors / darkColors) — do not hardcode palette hex here.
 *
 * @param {string} mode - 'light' or 'dark'
 * @returns {object} - MUI theme object
 */
export const createAppTheme = (mode = 'light') => {
  const { palette: p } = mode === 'dark' ? darkColors : lightColors;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: p.primary.main,
        dark: p.primary.dark,
        light: p.primary.light,
        contrastText: p.primary.contrastText,
      },
      secondary: {
        main: p.secondary.main,
        dark: p.secondary.dark,
        light: p.secondary.light,
        contrastText: p.secondary.contrastText,
      },
      background: {
        default: p.background.default,
        paper: p.background.paper,
      },
      text: {
        primary: p.text.primary,
        secondary: p.text.secondary,
        disabled: p.text.disabled,
      },
      success: {
        main: p.status.success,
        dark: p.status.successDark,
        contrastText: p.common.white,
      },
      warning: {
        main: p.status.warning,
        dark: p.status.warningDark,
        contrastText: p.common.white,
      },
      error: {
        main: p.status.error,
        dark: p.status.errorDark,
        contrastText: p.common.white,
      },
      info: {
        main: p.status.info,
        dark: p.status.infoDark,
        contrastText: p.common.white,
      },
      // App-specific extensions (still from tokens)
      status: p.status,
      grey: {
        ...p.grey,
      },
      custom: p.custom,
      action: {
        hover: p.action.hover,
        selected: p.action.selected,
      },
    },
    typography: {
      fontFamily: typography.fontFamily,
    },
    breakpoints: breakpoints,
    zIndex: zIndices,
    shape: {
      borderRadius: parseInt(radii.base, 10),
    },
    customShadows: shadows,
  });
};

// Export default theme (light mode) for backward compatibility
const theme = createAppTheme('light');
export default theme;
